import { render, staticRenderFns } from "./GameByTag.vue?vue&type=template&id=62929463&scoped=true&"
import script from "./GameByTag.vue?vue&type=script&lang=js&"
export * from "./GameByTag.vue?vue&type=script&lang=js&"
import style0 from "./GameByTag.vue?vue&type=style&index=0&id=62929463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62929463",
  null
  
)

export default component.exports